<mat-dialog-content>
  @if (mandatory) {
    <h3 style="color: #FF281B;">{{labels.lblWrongAns}}</h3>
    <div style="color: #FFF; margin: auto; text-align: center">
      <button class="button" [class]="buttons" mat-button (click)="onNoClick()" style="margin-top: 15px;"
              type="button" matDialogClose>{{labels.lblWatchAgain}}</button>
    </div>
  } @else {
    <h3 style="color: #FF281B;">{{labels.lblWrongAnsNonMandatory}}</h3>
    <h4 style="color: #FFF;">{{labels.lblCorrectAns}}</h4>
    @for (i of data.text; track i) {
    <h4>{{i}}</h4>
    }
    <div style="color: #FFF; margin: auto; text-align: center">
      <button class="button" [class]="buttons" mat-button (click)="onNoClick()" style="margin-top: 15px;"
      type="button" matDialogClose>{{labels.lblContinue}}</button>
    </div>
  }

</mat-dialog-content>
